/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scenarioInFlightOperationResponseSchema } from './scenarioInFlightOperationResponseSchema';
import { scenarioMetricsSchema } from './scenarioMetricsSchema';
import { scenarioSchema } from './scenarioSchema';

export const scenarioResponseSchema = z.object({
  get inFlightOperation() {
    return z.union([scenarioInFlightOperationResponseSchema, z.null()]).optional();
  },
  get metrics() {
    return z.union([scenarioMetricsSchema, z.null()]).optional();
  },
  get scenario() {
    return scenarioSchema;
  },
});
